<template>
  <UContainer>
    <UChangelogVersions :versions="versions">
      <template #body="{ version }">
        <MDC v-if="version.content" :value="version.content" />
      </template>
    </UChangelogVersions>
  </UContainer>
</template>

<script lang="ts" setup>
const versions = [
  {
    title: "Introducing v1.1.0",
    description: "Changelog v1.1.0!",
    date: "2026-03-10",
    content: `### 🤘🏼 Added

- Update CampaignDropzone to display current file number during upload (e.g., "Uploading 2 of 5 files...")
- Append file extension to ad folder names for non-zip files (e.g., "adname_jpg")
- Videos will now autoplay in Previewmodal
- added multiple Ad feedback support

### 💅 Changed

- Change uploadFiles utility to upload files sequentially instead of in batch
  `,
  },
  {
    title: "Introducing v1.2.0",
    description: "Changelog v1.2.0!",
    date: "2026-06-03",
    content: `### 🤘🏼 Added

- it is now possible to also upload pure svg files and review them
- the app now generates a thumnail for video ads
- notification Emails for ad creation, ad update and feedback now go out to all users associated with the campaign

### 🛠 Fixed

- ads are now set to review status when uploaded`,
  },
];
</script>

<style></style>
